<template>
  <div
    class="flex h-full flex-col overflow-hidden bg-background-fg/5"
  >
    <template v-if="$slots.header || $slots.title">
      <div
        :class="[
          'flex shrink-0 items-center px-4 pb-2 pt-4',
          hasContentAbove ? 'shadow-lg' : '',
        ]"
      >
        <DialogButtonClose
          class="mr-2"
          @click="handleClickClose"
        />
        <slot name="header">
          <PageTitle>
            <slot name="title" />
          </PageTitle>
        </slot>
      </div>
    </template>
    <div
      ref="scrollContainerRef"
      class="h-full overflow-y-auto px-4 pb-4 pt-2"
      :class="
        $slots.header || $slots.title ? 'pt-2' : 'pt-4'
      "
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useScroll } from "@vueuse/core"

const scrollContainerRef = useTemplateRef(
  "scrollContainerRef"
)
const { arrivedState } = useScroll(scrollContainerRef)

const hasContentAbove = computed(() => !arrivedState.top)

// const hasContentBelow = computed(() => !arrivedState.bottom)

const emit = defineEmits(["close"])

const handleClickClose = () => emit("close")
</script>
